import type {
  MarketplaceItem,
  MarketplaceItemStatus,
  MarketplaceItemType,
  MarketplacePricingModel,
} from "@itaas/pep-contracts";
import {
  MARKETPLACE_STATUS_LABELS,
  MARKETPLACE_TYPE_LABELS,
} from "@itaas/pep-contracts";

export function labelMarketplaceType(type: MarketplaceItemType): string {
  return MARKETPLACE_TYPE_LABELS[type] ?? type;
}

export function labelMarketplaceStatus(status: MarketplaceItemStatus): string {
  return MARKETPLACE_STATUS_LABELS[status] ?? status;
}

export function marketplaceDisplayName(item: MarketplaceItem): string {
  return item.displayNameFr ?? item.displayName;
}

export function marketplaceDescription(item: MarketplaceItem): string {
  return item.descriptionFr ?? item.description;
}

export function marketplaceStatusBadge(status: MarketplaceItemStatus): string {
  switch (status) {
    case "available":
      return "text-bg-success";
    case "beta":
      return "text-bg-primary";
    default:
      return "text-bg-secondary";
  }
}

export function formatPricingModel(model: MarketplacePricingModel, monthlyUsd?: number): string {
  switch (model) {
    case "free":
      return "Gratuit";
    case "included":
      return "Inclus";
    case "subscription":
      return monthlyUsd != null ? `À partir de ${monthlyUsd} USD/mois` : "Abonnement";
    case "one_time":
      return monthlyUsd != null ? `${monthlyUsd} USD` : "Achat unique";
    default:
      return "Sur devis";
  }
}
